export default "__VITE_ASSET__CQI1hni7__"